import * as React from 'react';


export var CrossIcon = function (_a) {
    var onClear = _a.onClear, className = _a.className;
    return (React.createElement("svg", { className: "CrossIcon " + className || '', onClick: onClear, width: "20px", height: "20px", viewBox: "0 0 20 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("title", null, "Icon/Close"),
        React.createElement("g", { id: "Icon/Close", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("g", { id: "Icon/close", transform: "translate(3.000000, 3.000000)", fill: "#292828" },
                React.createElement("polygon", { id: "close", points: "13.1751484 0 7 6.17512109 0.824851562 0 0 0.824851562 6.17514844 7 0 13.1751484 0.824851562 14 7 7.82485156 13.1751484 14 14 13.1751484 7.82485156 7 14 0.824851562" })))));
};
